import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'

const enforceProtocol = () => {
  const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)
  const expectedProtocol = isLocalhost ? 'http:' : 'https:'

  if (window.location.protocol !== expectedProtocol) {
    const { host, pathname, search, hash } = window.location
    window.location.replace(`${expectedProtocol}//${host}${pathname}${search}${hash}`)
  }
}

enforceProtocol()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root container not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
